/**
 * Shared SharePoint connect gate — the connection probe + click branch used
 * by every "Import/Attach from SharePoint" affordance. Replaces the pattern
 * previously copy-pasted across LibraryToolbar, BidDocumentsToolbar,
 * CreateBidDialog and ArtifactDetailPage.
 */
import { useCallback } from 'react'
import { useSharePointStore } from '@/stores/sharepoint-store'

export function useSharePointGate() {
  const isConnected = useSharePointStore((s) => s.isConnected)
  const checkConnection = useSharePointStore((s) => s.checkConnection)
  const beginConnect = useSharePointStore((s) => s.beginConnect)

  const ensureChecked = useCallback(() => {
    void checkConnection()
  }, [checkConnection])

  const openOrConnect = useCallback(
    (openPicker: () => void, returnTo?: string) => {
      // Read live state: this callback is stable, so a connection that lands
      // after render must not be missed by a handler a child still holds.
      if (useSharePointStore.getState().isConnected) {
        openPicker()
      } else {
        void beginConnect(returnTo ?? window.location.pathname)
      }
    },
    [beginConnect]
  )

  return { isConnected, ensureChecked, openOrConnect }
}
